import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import ApiService from '../ApiService'
import { FORGOT_PASSWORD } from '../constants'
import '../scss/login.scss'
import { useStates } from '../StateProvider'
import { useAuth } from './hooks/useAuth'

const LoginPage = () => {
  const { login, client } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [responseError, setResponseError] = useState('')
  const { showToast } = useStates()
  const [emailForgot, setForgotEmail] = useState('')
  const [resetSuccess, setResetSuccess] = useState(null)
  const [responseForgotError, setResponseForgotError] = useState('')
  const [emailModalError, setEmailModalError] = useState('')
  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  // Errro --> To-Do
  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleEmailForgotChange = (e) => {
    setForgotEmail(e.target.value)
  }

  useEffect(() => {
    console.log(resetSuccess)
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setResponseError('')
    setEmailError('')
    setPasswordError('')
    if (!email) {
      setEmailError('Please enter an email')
    } else if (!password) {
      setPasswordError('Please enter a password')
    } else {
      try {
        const data = await login({
          email,
          password
        })
        if (!data.success) {
          setResponseError(data.error)
        } else {
          showToast('Login Sucessfully', 'success')
        }
      } catch (error) {
        console.error('Error occurred during login:', error)
        setResponseError('An error occurred during login') // Display a generic error message
      }
    }
  }

  // Forgot password handle submit
  const handleSubmitForgotPassword = async () => {
    setEmailModalError('')

    if (!emailForgot) {
      setEmailModalError('Please enter your email address.')
    } else {
      try {
        const { success, data, error } = await ApiService.makeApiCall(
          FORGOT_PASSWORD,
          'GET',
          null,
          null,
          emailForgot
        )
        if (success) {
          setResponseForgotError('')
          const token = data.token
          localStorage.setItem('token', token)
          setResetSuccess('Sent reset password mail successful')
          // showToast('Sent reset password mail successful')

          // Hide the modal
          const modalEl = document.getElementById('forgotPasswordModal')
          modalEl.style.display = 'none'
          modalEl.classList.remove('show')
          // Remove backdrop
          const backdrop = document.querySelector('.modal-backdrop')
          if (backdrop) {
            backdrop.parentNode.removeChild(backdrop)
          }

          document.body.classList.remove('modal-open')
          document.body.style = ''
        } else {
          setResponseForgotError(error || 'Invalid Email') // Display appropriate error message
        }
      } catch (error) {
        console.error('Error occurred while sending mail:', error)
        setResponseForgotError('An error occurred while sending mail') // Display a generic error message
      }
    }
  }

  if (client) {
    let isAdmin = false
    client.role_TYPE?.forEach((role) => {
      if (role.authority.includes('ROLE_ADMIN')) {
        isAdmin = true
      }
    })
    if (isAdmin) {
      return <Navigate to="/license" />
    } else {
      return <Navigate to="/gps" />
    }
  }

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center vh-100 main-login"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div
              className="col-md-6 d-none d-md-block"
              style={{
                backgroundColor: '#2C6FEB',
                height: '100vh',
                position: 'absolute',
                top: 0,
                left: 0
              }}
            >
              <div className="position-absolute top-0 start-0 m-4 text-white fw-bold top-left-logo">
                LOG
                <span
                  style={{
                    backgroundColor: 'white',
                    color: '#2C6FEB',
                    padding: '5px',
                    borderRadius: '4px'
                  }}
                  className="top-left-logo ms-1"
                >
                  BOOK
                </span>
              </div>
            </div>

            <div className="logo">
              LOG <span>BOOK</span>
            </div>

            {/* Right Section */}
            <div className="col-md-6 bg-white p-4 shadow rounded right-section-align">
              <h3 className="fw-600 global-font-login font-weight-login">
                Login
              </h3>
              <p className="text-muted global-font-login login-heading">
                Enter your email below to login to your account
              </p>

              <div className="mb-3 mb-sm-2">
                <label className="form-label global-font-login login-title mb-0 align-login-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control custom-input ms-0"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => handleEmailChange(e)}
                />
              </div>

              <div className="mb-3 mb-sm-2 align-password">
                <label className="form-label global-font-login login-title mb-0">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control custom-input ms-0"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => handlePasswordChange(e)}
                />
              </div>

              <div className="text-end mb-3 mb-sm-2 mobile-align">
                <a
                  href="#"
                  className="text-muted global-font-login forgot-password"
                  data-bs-toggle="modal"
                  data-bs-target="#forgotPasswordModal"
                  onClick={() => {
                    setResponseForgotError('')
                    setEmailModalError('')
                  }}
                >
                  Forgot your Password?
                </a>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-2 justify-content-center btn-align">
                <button
                  className="btn text-white w-50 login-title login-btn-font align-login-mobile"
                  style={{ backgroundColor: '#00C72E' }}
                  onClick={handleSubmit}
                >
                  Login
                </button>
                {/* <button className="btn btn-primary w-50 login-title login-btn-font align-login-with-mobile align-login-with-web">
                  <span className="login-title login-btn-font me-2">
                    Login with
                  </span>
                  <img
                    className="logo_image google-logo-align"
                    style={{ width: '20px', height: '20px' }}
                    src="images/google-brands.svg"
                    alt="logo"
                  />
                </button> */}
              </div>
              {emailError && (
                <p className="error text-danger text-center mt-4 error-code-text-font">
                  {emailError}
                </p>
              )}
              {passwordError && (
                <p className="error text-danger text-center mt-4 error-code-text-font">
                  {passwordError}
                </p>
              )}
              {responseError && (
                <p className="error text-danger text-center mt-4 error-code-text-font">
                  {'Invalid Credentials'}
                </p>
              )}
              {/* Signup */}
              {/* <div className="text-center mt-3 mb-4 align-dont-have-web">
                <span className="global-font-login dont-have-account">
                  Don’t have an account?{' '}
                </span>
                <Link
                  to="#"
                  className="fw-bold dont-have-account login-btn-font"
                  style={{ color: '#2C6FEB', cursor: 'pointer' }}
                >
                  Sign up
                </Link>
              </div> */}
            </div>
          </div>
        </div>
        {/* Forgot password modal Code */}
        <div
          className="modal fade main-forgot-modal"
          id="forgotPasswordModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              {/* Modal Header */}
              <div className="modal-header border-0">
                <h5 className="modal-title fw-bold text-dark forgot-text-align">
                  Forgot Password
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <hr className="align-hr" />
              {/* Modal Body */}
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label fw-semibold forgot-txt-modal-sub-head">
                    Email Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control custom-input-modal ms-0"
                    placeholder="Enter your email"
                    value={emailForgot}
                    onChange={(e) => handleEmailForgotChange(e)}
                  />
                </div>
              </div>
              {responseForgotError ? (
                <p className="error text-danger text-center mt-2 error-code-text-font">
                  {responseForgotError}
                </p>
              ) : emailModalError ? (
                <p className="error text-danger text-center mt-2 error-code-text-font">
                  {emailModalError}
                </p>
              ) : (
                ''
              )}

              {/* Modal Footer */}
              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn custom-btn w-10 reset-password"
                  onClick={() => handleSubmitForgotPassword()}
                >
                  Send Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default LoginPage
